import React, { Component } from 'react';
import { connect } from 'react-redux';
import { each, filter, values } from 'lodash';
import PropTypes from 'prop-types';
import { ButtonGroup, Button } from 'react-bootstrap';
import { 
  getProgressLoadPercentage,
  getProgressStats,
} from '../../../Dashboard/DashboardReducer';
import ProgressBar from '../../../../components/progress-bar';

import NumberDisplay from '../../../../components/number-display';
import Counter from '../../../../components/counter';
import OwnerTable from '../owner-table';
import ResourceTable from '../resource-table';

import {
  getWinLossOpportunities,
  getWinLossAccounts,
} from '../../../Dashboard/DashboardReducer';


class ReminderTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewType: 'objects',
    };
    this.onToggleViewType = this.onToggleViewType.bind(this);
  }

  onToggleViewType(viewType) {
    this.setState({ viewType });
  }

  getTableControls(owners) {
    const { viewType } = this.state;
    const { isAccount } = this.props;

    const buttons = [
      { id: 'objects', label: isAccount ? 'Accounts' : 'Opportunities', count: this.props.objects.length },
      ...(owners.length > 0 ? [{ id: 'owners', label: 'Sales Reps', count: owners.length }] : []),
    ];

    const comps = [];
    each(buttons, (button) => {
      if (button.id) {
        comps.push((
          <Button key={button.id} active={viewType === button.id} onClick={() => { this.onToggleViewType(button.id); }}>
            <span>
              <span className="badge">
                <Counter value={button.count}>
                  <NumberDisplay value={button.count} precision={0} />
                </Counter>
              </span>
              {' '}
              {button.label}
            </span>
          </Button>
        ));
      }
    });


    return (
      <ButtonGroup>
        {comps}
      </ButtonGroup>
    );
  }

  
  render() {
    const { viewType } = this.state;
    const { isAccount, progressStats, objects, loadPercentage } = this.props;
    const owners = values(progressStats['reminders/owners']);

    if (objects.length === 0 && loadPercentage < 1) {
      return (
        <ProgressBar />
      );
    }


    return (
      <div>
        {viewType === 'objects' &&
          <ResourceTable
            resources={objects}
            isAccount={isAccount}
            tableName={isAccount ? 'progress-account-table' : 'progress-opportunity-table'}
            tableControls={this.getTableControls(owners)}
          />
        }
        {viewType === 'owners' &&
          <OwnerTable
            isAccount={isAccount}
            owners={owners}
            showStats={this.props.showStats}
            tableControls={this.getTableControls(owners)}
          />
        }
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { isAccount } = ownProps;
  const objects = isAccount ? getWinLossAccounts(state) : getWinLossOpportunities(state);

  return {
    loadPercentage: getProgressLoadPercentage(state),
    progressStats: getProgressStats(state),
    objects: filter(objects, (o) => {
      return o.reminders > 0;
    }),
  };
}


ReminderTable.propTypes = {
  progressStats: PropTypes.shape({

  }).isRequired,
  loadPercentage: PropTypes.number,
  isAccount: PropTypes.bool,
  showStats: PropTypes.func,
  objects: PropTypes.arrayOf(PropTypes.shape({})),
};
ReminderTable.defaultProps = {
  isAccount: false,
  loadPercentage: 0,
  progressStats: {},
  showStats: () => {},
  objects: [],
};
ReminderTable.contextTypes = {
};

export default connect(mapStateToProps)(ReminderTable);